const types = {
    BACKEND_SETTING_CAROUSEL_BANNER_ARRAY: 'BACKEND_SETTING_CAROUSEL_BANNER_ARRAY',
    BACKEND_SETTING_TOP_BACKGROUND_IMG_URL: 'BACKEND_SETTING_TOP_BACKGROUND_IMG_URL',
    BACKEND_SETTING_DEPOSIT_TOP_BACKGROUND_IMG_URL: 'BACKEND_SETTING_DEPOSIT_TOP_BACKGROUND_IMG_URL'
}


const state = {
    carouselBannerArray: "",
    topBackgroundImgUrl: "",
    depositTopBackgroundImgUrl: ""
}


const getters = {
    getCarouselBannerArray: state => state.carouselBannerArray,
    getTopBackgroundImgUrl: state => state.topBackgroundImgUrl,
    getDepositTopBackgroundImgUrl: state => state.depositTopBackgroundImgUrl
}


const actions = {
    actionSetCarouselBannerArray({ commit }, carouselBannerArray) {
        commit(types.BACKEND_SETTING_CAROUSEL_BANNER_ARRAY, carouselBannerArray)
    },
    actionSetTopBackgroundImgUrl({ commit }, topBackgroundImgUrl) {
        commit(types.BACKEND_SETTING_TOP_BACKGROUND_IMG_URL, topBackgroundImgUrl);
    },
    actionSetDepositTopBackgroundImgUrl({ commit }, depositTopBackgroundImgUrl) {
        commit(types.BACKEND_SETTING_DEPOSIT_TOP_BACKGROUND_IMG_URL, depositTopBackgroundImgUrl);
    }
}


const mutations = {
    [types.BACKEND_SETTING_CAROUSEL_BANNER_ARRAY](state, carouselBannerArray) {
        state.carouselBannerArray = carouselBannerArray;
    },
    [types.BACKEND_SETTING_TOP_BACKGROUND_IMG_URL](state, topBackgroundImgUrl) {
        state.topBackgroundImgUrl = topBackgroundImgUrl;
    },
    [types.BACKEND_SETTING_DEPOSIT_TOP_BACKGROUND_IMG_URL](state, depositTopBackgroundImgUrl) {
        state.depositTopBackgroundImgUrl = depositTopBackgroundImgUrl;
    }
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}